import React from 'react';

const ReportContext = React.createContext('report');

export const ReportContextProvider = ReportContext.Provider;

export default ReportContext;
